export default {
	"components.Backtrack": "Backtrack",
	"components.RefundPath": "Refund path",
	"components.refundAmount": "refund amount"
}